// Third-party libraries
import React, { useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";

// Local modules
import { Diamond360Icon } from "../../Icons";
import Shape from "../shapes/Shape";
import DiamondIconStrip from "./DiamondIconStrip";
import placeholder from "../../../assets/images/DiaImageComingSoon.jpg";

export default function MediaPanel({
  diamond,
  popover,
  context_class,
  details,
}) {
  const MEDIA_VIEW = {
    TOP_DIAGRAM: "TopDiagram",
    PROFILE_DIAGRAM: "ProfileDiagram",
    VIDEO_360: "Video360",
    TOP_IMAGE: "TopImage",
  };

  const [mediaView, setMediaView] = useState(MEDIA_VIEW.TOP_IMAGE);
  const [imageError, setImageError] = useState(false);

  const EmbedURL = diamond.VideoLink;
  const showVideoOption = Boolean(EmbedURL);
  const showImageOption = Boolean(diamond.ImageLink);

  useEffect(() => {
    const defaultView =
      (showVideoOption && MEDIA_VIEW.VIDEO_360) ||
      (showImageOption && MEDIA_VIEW.TOP_IMAGE) ||
      MEDIA_VIEW.TOP_DIAGRAM;

    setMediaView(defaultView);
    setImageError(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [diamond]);

  const mediaClass = context_class || (popover && "add-to-cart-popover") || "";

  const renderMedia = () => {
    switch (mediaView) {
      case MEDIA_VIEW.VIDEO_360:
        return (
          <iframe
            src={EmbedURL}
            title="diamond_360"
            width="100%"
            height="500px"
            style={{
              border: "none",
              display: "block",
              margin: "0 auto",
            }}
          />
        );

      case MEDIA_VIEW.TOP_IMAGE:
        const sharedImageStyle = {
          width: "100%",
          maxWidth: "400px",
          height: "auto",
          objectFit: "contain",
          display: "block",
          margin: "0 auto",
        };

        return (
          <img
            src={!imageError ? diamond.ImageLink : placeholder}
            alt={!imageError ? "Diamond Top View" : "Placeholder"}
            className={`diamond-image-diagram ${mediaClass}`}
            style={sharedImageStyle}
            onError={() => setImageError(true)}
          />
        );

      case MEDIA_VIEW.TOP_DIAGRAM:
        return (
          <span className="diamond-image-diagram">
            <Shape
              type={diamond.Shape}
              color="silver"
              show_diagram={true}
              diamond={diamond}
              strokeWidthFactor="0.007"
              stroke_width="0.3"
              width="350"
              height="350"
            />
          </span>
        );

      case MEDIA_VIEW.PROFILE_DIAGRAM:
        return (
          <span className="diamond-image-diagram">
            <Shape
              type={diamond.Shape + "Profile"}
              color="silver"
              strokeWidthFactor="0.01"
              diamond={diamond}
              show_diagram={true}
              width="350"
              height="350"
            />
          </span>
        );

      default:
        return null;
    }
  };

  return (
    <>
      {renderMedia()}
      <Box>
        <Stack
          direction="row"
          gap={2}
          justifyContent="center"
          alignItems="center"
        >
          {showVideoOption && (
            <div
              onClick={() => setMediaView(MEDIA_VIEW.VIDEO_360)}
              className="pointer thumbnail"
            >
              <Diamond360Icon size="regular" />
            </div>
          )}

          {showImageOption && (
            <div
              onClick={() => setMediaView(MEDIA_VIEW.TOP_IMAGE)}
              className="pointer thumbnail"
            >
              {!imageError ? (
                <img
                  src={diamond.ImageLink}
                  width="48"
                  height="48"
                  alt="Diamond Top View"
                  onError={() => setImageError(true)}
                />
              ) : (
                <span>Image</span>
              )}
            </div>
          )}

          <div
            onClick={() => setMediaView(MEDIA_VIEW.TOP_DIAGRAM)}
            className="pointer thumbnail"
          >
            <Shape
              type={diamond.Shape}
              color="darkgrey"
              width="46"
              height="46"
              show_diagram={false}
              diamond={diamond}
              strokeWidthFactor="0.01"
            />
          </div>

          <div
            onClick={() => setMediaView(MEDIA_VIEW.PROFILE_DIAGRAM)}
            className="pointer thumbnail"
          >
            <Shape
              type={diamond.Shape + "Profile"}
              color="darkgrey"
              width="46"
              height="46"
              show_diagram={false}
              diamond={diamond}
              strokeWidthFactor="0.01"
            />
          </div>

          {!details && <DiamondIconStrip diamond={diamond} show_text={true} />}
        </Stack>
      </Box>
    </>
  );
}
